import React from "react";
import { useSelector } from "react-redux";
import LeaveRequestTable from "../../Usual/HRMS/Components/LeaveRequest/Components/LeaveRequestTable";

const ManagerLeaveRequestView = () => {
  const { hrmsUser, userType } = useSelector((state) => state.auth);
  console.log("HRMS User Data in ManagerLeaveRequestView:", hrmsUser.employee_id);

  const isHotelManager =
    userType === "hrms" &&
    String(hrmsUser?.designation || hrmsUser?.vchDesignation || "")
      .trim()
      .toLowerCase()
      .includes("manager");

  if (!isHotelManager) {
    return (
      <div className="container-fluid">
        <div className="alert alert-warning mt-3 mb-0">
          This page is only available for Manager accounts.
        </div>
      </div>
    );
  }

  const managerName =
    hrmsUser?.name || hrmsUser?.vchFullName || hrmsUser?.employeeName || "";

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Staff Leave Requests</h3>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <LeaveRequestTable managerScope managerName={managerName} managerId={hrmsUser.employee_id} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerLeaveRequestView;
